// ESLint rule disabled intentionally (false positive).
/* eslint-disable @next/next/no-html-link-for-pages */
// NOTE: Next linting rules might suggest using the Link component instead of an anchor tag.
// The Link component is meant to perform client-side transitions between pages.
// As the link points to an API route and not to a page, you should keep it as an anchor tag.
// https://auth0.com/docs/quickstart/webapp/nextjs#add-login-to-your-application
// Also, button with router.push() cannot be used, auth0 will not work.
'use client'

import { useLogger } from 'next-axiom'
import { useUser } from '@auth0/nextjs-auth0'

const Logout = () => {
  return (
    /* @@TODO: move gap-x-2 to parent container */
    <div className="gap-x-2">
      <a
        href="/auth/logout"
        id="logout"
        className="flex w-20 h-7 rounded-md justify-center items-center border-custom focus-custom"
      >
        <div className="text-sm break-keep">Logout</div>
      </a>
    </div>
  )
}

export const Signup = () => {
  return (
    <a
      href="/auth/login?screen_hint=signup"
      id="signup"
      className="flex w-20 h-7 rounded-md justify-center items-center border-custom focus-custom"
    >
      <div className="text-sm break-keep">Sign up</div>
    </a>
  )
}

export const Anonymous = () => {
  return (
    /* @@TODO: move gap-x-2 to parent container */
    <div className="gap-x-2">
      <a
        href="/auth/login"
        id="login"
        className="focus-custom flex w-20 h-7 rounded-md justify-center items-center border-custom"
      >
        <div className="text-sm break-keep">Login</div>
      </a>
    </div>
  )
}

export const Authorizing = () => {
  return (
    <div className="flex w-20 rounded-md justify-center items-center">
      <div className="text-sm break-keep" id="authorizing">
        Authorizing...
      </div>
    </div>
  )
}

const AuthError = () => {
  return (
    <div className="rounded-md">
      <div className="flex w-20 rounded-md justify-center items-center">
        <div
          className="text-sm break-keep text-red-500 dark:text-red-500"
          id="error"
        >
          Error
        </div>
      </div>
    </div>
  )
}

const Auth = () => {
  const { user, isLoading, error } = useUser()
  // @@TODO: Explain how (user !== undefined) differs from (user)
  const log = useLogger()

  let auth = <Anonymous />
  /*
  if (error) {
    console.log('Auth error', error)
    log.error('Auth error', { message: error.message, stack: error.stack })
    auth = <AuthError />
  }
  */
  if (isLoading) {
    auth = <Authorizing />
  }
  if (user) {
    auth = <Logout />
  }
  return <div className="flex w-fit justify-end">{auth}</div>
}

export default Auth
